const iconEyes = document.querySelectorAll(".eye-icon");

if (iconEyes) {
  iconEyes.forEach((iconEye) => {
    iconEye.addEventListener("click", (event) => {
      // Use event.composedPath() instead of event.path, as event.path is undefined on Safari/Firefox
      // https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath
      let eventPath = event.composedPath()

      if (!(eventPath[1].children[0].hasAttribute("type"))) return;
      const input = eventPath[1].children[0];
      const showPassword = eventPath[1].querySelector(".show-password");
      const hidePassword = eventPath[1].querySelector(".hide-password");

      if (input.getAttribute("type") === "password") {
        input.setAttribute("type", "text");
      } else {
        input.setAttribute("type", "password");
      }

      showPassword.classList.toggle("d-none");
      hidePassword.classList.toggle("d-none");
    })
  })
}
